import CONFIG from '../../config';

const actions = {
  gstinConsent(context, params) {
    context.commit('ADD_LOG', { request: 'gstinConsent' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('gstinConsent', params.applicationId), {}, {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gstinConsent' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gstinConsent' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gstinOtp(context, params) {
    context.commit('ADD_LOG', { request: 'gstinOtp' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('gstinOtp', params.applicationId), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gstinOtp' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gstinOtp' });
          context.dispatch('resolveError', { err, hideError: true })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gstinLogin(context, params) {
    context.commit('ADD_LOG', { request: 'gstinLogin' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('gstinLogin', params.applicationId), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gstinLogin' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gstinLogin' });
          context.dispatch('resolveError', { err, hideError: true })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
};
export default actions;
